var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",class:{ wicon: _vm.icon },on:{"click":_vm.click}},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('icon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_c('span',{staticClass:"link"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37598488","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/Action.vue
// module id = 368
// module chunks = 8